import { styled } from '@linaria/react';

import { semantic, size, space } from '../../theme/tokens';

export const Card = styled.div`
  border: 1px solid ${semantic.border.default};
  border-radius: ${size.radius['radius-md']};
  background: ${semantic.bg.canvas};
  padding: ${space['space-600']};
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;

export const DiscountStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;
